import { CheckoutSteps } from '../../util/enums';
import { hasCompleteProjectInformation } from './MultiStepCheckoutPanel/projectInfoHelpers';

export const RESUME_PAYMENT_PARAM = 'resumePayment';

export const isResumePaymentRequested = value =>
  value === true || value === 1 || value === 'true' || value === '1';

const valueMaybe = (key, value) => (value !== null && value !== undefined ? { [key]: value } : {});

const OMISE_FEE_LINE_ITEM = 'line-item/omise-fee';

const getOmisePaymentFee = transaction => {
  const protectedData = transaction?.attributes?.protectedData || {};
  const lineItems = transaction?.attributes?.lineItems || [];
  const feeLineItem = lineItems.find(item => item.code === OMISE_FEE_LINE_ITEM && !item.reversal);

  return protectedData.omisePaymentFee ?? feeLineItem?.lineTotal?.amount;
};

export const buildResumePaymentOrderData = transaction => {
  const protectedData = transaction?.attributes?.protectedData || {};
  const metadata = transaction?.attributes?.metadata || {};
  const booking = transaction?.booking;
  const bookingStart = booking?.attributes?.start;
  const bookingEnd = booking?.attributes?.end;
  const bookingDates =
    bookingStart && bookingEnd
      ? {
          bookingDates: {
            bookingStart,
            bookingEnd,
          },
        }
      : {};

  return {
    ...bookingDates,
    ...valueMaybe('deliveryMethod', protectedData.deliveryMethod),
    ...valueMaybe('quantity', protectedData.quantity),
    ...valueMaybe('seats', protectedData.seats),
    ...valueMaybe('bookingModalDetails', protectedData.bookingModalDetails),
    ...valueMaybe('customOffer', protectedData.customOffer),
    ...valueMaybe('addons', protectedData.addons),
    ...valueMaybe('projectInformation', protectedData.projectInformation),
    ...valueMaybe('paymentMethod', protectedData.paymentMethod || metadata.paymentMethod),
    ...valueMaybe('selectedBank', protectedData.selectedBank || metadata.selectedBank),
    ...valueMaybe('omisePaymentFee', getOmisePaymentFee(transaction)),
  };
};

export const buildResumePaymentCheckoutInitialValues = ({ transaction, listing }) => ({
  listing,
  transaction,
  orderData: buildResumePaymentOrderData(transaction),
  confirmPaymentError: null,
});

export const shouldLockProjectInfoStep = ({ transaction, process }) => {
  if (!transaction?.id || !process) {
    return false;
  }

  const transactionState = process.getState(transaction);
  const projectInformation = transaction?.attributes?.protectedData?.projectInformation;

  return (
    transactionState === process?.states?.ACCEPTED_PENDING_PAYMENT &&
    hasCompleteProjectInformation(projectInformation)
  );
};

export const getProtectedCheckoutTab = ({
  requestedTab,
  projectInfoLocked,
  projectInfoRequired,
}) => {
  if (projectInfoLocked) {
    return CheckoutSteps.PAYMENT;
  }

  if (requestedTab === CheckoutSteps.PAYMENT && projectInfoRequired) {
    return CheckoutSteps.PROJECT_INFO;
  }

  return requestedTab;
};
